import React, { useState, useEffect } from 'react';
import { Link as RouterLink, useParams, useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import PageShell from '../components/PageShell';
import RoomView from '../components/RoomView';

function StoreRoom() {
    const { id } = useParams();
    const [token] = useState(localStorage.getItem('storeToken'));
    const storeName = localStorage.getItem('storeName');
    const navigate = useNavigate();

    useEffect(() => {
        if (!token) navigate('/store/login');
    }, [token, navigate]);

    const logout = () => {
        localStorage.removeItem('storeToken');
        localStorage.removeItem('storeName');
        navigate('/store/login');
    };

    const nav = (
        <>
            <Button component={RouterLink} to="/store/dashboard" color="inherit">Volver al Panel</Button>
            <Button onClick={logout} variant="outlined" color="inherit">Cerrar Sesión</Button>
        </>
    );

    if (!token) return null;

    return (
        <PageShell title={`Sala en Vivo${storeName ? `: ${storeName}` : ''}`} nav={nav}>
            <RoomView
                token={token}
                role="store"
                fetchPath={`/store/rooms/${id}`}
                headerExtra={<Chip label="Vista de la tienda" color="primary" variant="outlined" />}
            />
        </PageShell>
    );
}

export default StoreRoom;
